import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import CartItems from './CartItems';
import Voucher from './Voucher';
import Button from '../Elements/Button/Button';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import { hasClass, removeClass } from '../../utils/dom';
import { translate, prefix } from '../../utils/locale';
import s from './Cart.scss';

const Cart = ({ checkout, setup, maxHeight, trust, toggleCartHandler }) => {
	const closeCart = () => {
		if (hasClass(document.body, 'u_addedToBag')) {
			removeClass(document.body, 'u_addedToBag');
		} else {
			toggleCartHandler();
		}
	};

	return (
		<div className={s.cart} style={{ maxHeight: `${maxHeight}px` }}>
			<div className={s.cart_header}>
				<span className={s.cart_header_title}>{ translate(setup, `cartItemsInBag${checkout.selection?.totals?.totalQuantity !== 1 ? 'Plural' : ''}`).replace(/%[^%]+%/, checkout.selection?.totals?.totalQuantity || 0) }</span>
				<a className={s.cart_header_close} href="#close-cart" onClick={toggleCartHandler}>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M0 0.706483L0.707 0L13.435 12.7187L12.728 13.4252L0 0.706483Z" fill="black" />
						<path d="M0.707 13.4252L0 12.7187L12.728 0L13.435 0.706483L0.707 13.4252Z" fill="black" />
					</svg>
				</a>
			</div>
			{
				checkout.selection.items && checkout.selection.items.length > 0 && (
					<>
						<div className={s.cart_items}>
							<ErrorBoundary message="CartItems:" debugData={checkout.selection.items}>
								<CartItems toggleCartHandler={toggleCartHandler} />
							</ErrorBoundary>
						</div>
						<div className={s.cart_voucher}>
							<Voucher checkout={checkout} selection={checkout.selection} setup={setup} initVoucherShowing={false} />
						</div>
						<div className={[s.cart_totals, checkout.selection.items && checkout.selection.items.length > 0 ? s.cart_totals_hasItems : null].join(' ')}>
							<div className={s.cart_totals_row}>
								<span className={s.cart_totals_row_left}>{ translate(setup, 'checkoutProductTotal') }</span>
								<span className={s.cart_totals_row_right}>{ checkout.selection.totals.itemsTotalPrice }</span>
							</div>
							<div className={s.cart_totals_row}>
								<span className={s.cart_totals_row_left}>{ translate(setup, 'checkoutShipping') }</span>
								<span className={s.cart_totals_row_right}>{ checkout.selection.totals.shippingPrice }</span>
							</div>
							{
								checkout.selection.totals.totalDiscountPriceAsNumber !== false && (
									<div className={[s.cart_totals_row, s.cart_totals_row__discount].join(' ')}>
										<span className={s.cart_totals_row_left}>{ translate(setup, 'checkoutDiscount') }</span>
										<span className={s.cart_totals_row_right}>{ checkout.selection.totals.totalDiscountPrice }</span>
									</div>
								)
							}
							<div className={[s.cart_totals_row, s.cart_totals_row__grandTotal].join(' ')}>
								<span className={s.cart_totals_row_left}>{ translate(setup, 'checkoutGrandTotal') }</span>
								<span className={s.cart_totals_row_right}>{ checkout.selection.totals.grandTotalPrice }</span>
							</div>
						</div>
						<div className={s.cart_checkout}>
							<Button type={checkout.klarnaLoaded ? 'a' : 'link'} location={prefix(setup, 'selection')} href={prefix(setup, 'selection')} clickEventHandler={closeCart}>
								{ translate(setup, 'cartGoToCheckout') }
							</Button>
						</div>
						{
							(trust.message || trust.icons) && (
								<div className={s.cart_trust}>
									{
										trust.message.map((trustMessage) => {
											if (trustMessage.restricted && trustMessage.restricted.indexOf(setup.country) === -1) return null;
											return <div key={trustMessage.key} className={s.cart_trust_message}>{ translate(setup, trustMessage.text) }</div>;
										})
									}
									{
										trust.icons && (
											<div className={s.cart_trust_icons}>
												{
													trust.icons.map((trustIcon) => {
														if (trustIcon.restricted && trustIcon.restricted.indexOf(setup.country) === -1) return null;
														return (
															<div key={trustIcon.key} className={s.cart_trust_icon}>
																<img src={trustIcon.icon.url} alt={trustIcon.icon.alt} />
															</div>
														);
													})
												}
											</div>
										)
									}
								</div>
							)
						}
					</>
				)
			}
		</div>
	);
};

const mapState = ({ checkout, environment }, props) => {
	const { setup, header, trust } = environment;
	return { checkout, setup, header, trust, ...props };
};

export default hot(module)(connect(mapState)(Cart));
